import React, { Fragment } from 'react'
import {
  Dialog,
  Form,
  color,
  withNotifier,
  ModalV2,
  Button,
  mediaUp,
  margin,
  ThumbIcon
} from 'stylist'
import SubmitReelFeedbackMutation from 'mutations/SubmitReelFeedback'
import styled, { css } from 'react-emotion'
import { object, string } from 'yup'
import Sentry from 'config/sentry'

const StyledDialog = styled(Dialog)`
  color: ${color('slate')};
`

const TextGroup = styled(Form.Group)`
  width: 80%;
  display: inline-flex;
`

const ThumbsGroup = styled(Form.Group)`
  width: 20%;
  top: 50%;
  display: inline-flex;
`

const schema = object().shape({
  positive: string().required('Please choose thumbs up or thumbs down')
})

const ReelFeedbackContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  > ${Button} {
    ${mediaUp('md')} {
      ${margin('xs')};
    }
    &:first-child {
      margin-right: 0;
    }
  }
`
const selectedIconProps = selected =>
  selected ? { fill: 'slate', color: 'ink' } : { color: 'slate' }

const ReelFeedbackModal = ({ hide, notify, videoId, children }) => (
  <ModalV2
    render={({ hide }) => (
      <SubmitReelFeedbackMutation videoId={videoId}>
        {submitReelFeedback => (
          <StyledDialog size="lg">
            <Dialog.Header onClose={hide}>
              <Dialog.Title>Did you find these clips useful?</Dialog.Title>
            </Dialog.Header>

            <Form
              onSubmit={data => {
                submitReelFeedback(data.positive, data.text)
                  .then(() => notify('success', 'Thanks for your feedback!'))
                  .then(hide)
                  .catch(error => Sentry.captureException(error))
              }}
              validationSchema={schema}
            >
              <Dialog.Body>
                <p>
                  Please let us know by clicking like or dislike. Your feedback
                  will help us select better clips for you next time!
                </p>
                <TextGroup>
                  <Form.Textarea
                    className={css`
                      resize: vertical;
                    `}
                    name="text"
                  />
                </TextGroup>
                <ThumbsGroup buttons>
                  <ReelFeedbackContainer>
                    <Form.Value name="positive">
                      {({ setValue, value }) => (
                        <Fragment>
                          <Button
                            size="sm"
                            kind="ghost"
                            onClick={e => {
                              e.stopPropagation()
                              setValue(true)
                            }}
                            disabled={value}
                          >
                            <ThumbIcon
                              direction="up"
                              {...selectedIconProps(value)}
                            />
                          </Button>
                          <Button
                            size="sm"
                            kind="ghost"
                            onClick={e => {
                              e.stopPropagation()
                              setValue(false)
                            }}
                            disabled={value === false}
                          >
                            <ThumbIcon
                              direction="down"
                              {...selectedIconProps(value === false)}
                            />
                          </Button>
                        </Fragment>
                      )}
                    </Form.Value>
                  </ReelFeedbackContainer>
                </ThumbsGroup>
                <Form.Input type="hidden" name="positive" value={null} />
              </Dialog.Body>
              <Dialog.Footer>
                <Form.Group buttons>
                  <Dialog.CancelButton onClose={hide}>
                    No Thanks
                  </Dialog.CancelButton>
                  <Form.SubmitButton>Submit</Form.SubmitButton>
                </Form.Group>
              </Dialog.Footer>
            </Form>
          </StyledDialog>
        )}
      </SubmitReelFeedbackMutation>
    )}
    dismissable={true}
  >
    {children}
  </ModalV2>
)

export default withNotifier(ReelFeedbackModal)



// WEBPACK FOOTER //
// ./src/routes/video/components/ReelFeedbackModal.js